<div id="top-header">
  <div id="top-header-info">
    <nav id="top-nav-hamburger" class="d-block d-sm-none navbar navbar-dark">
      <button
        class="navbar-toggler"
        type="button"
        (click)="toggleSidebar()"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </nav>
    <div id="logout-button-wrapper">
      <div id="logoutButton" (click)="logout()">
        <i class="fa fa-sign-out  fa-2x"></i><br />
        Log Out
      </div>
    </div>
    <div id="username-role" class="globalHeaderUsername">
      <strong>{{ user.userFullName | uppercase }}</strong
      ><br />
      {{ role | uppercase }}
    </div>
  </div>
</div>
